import { getCurrentUser } from '../utils/auth';

function TopBar({ title, rightAction = null }) {
  const user = getCurrentUser();

  return (
    <header style={styles.bar}>
      <div>
        <h1 style={styles.title}>{title}</h1>
        {user?.name && <div style={styles.welcome}>Welcome, {user.name}</div>}
      </div>
      {rightAction && <div>{rightAction}</div>}
    </header>
  );
}

const styles = {
  bar: {
    height: 64,
    backgroundColor: 'white',
    borderBottom: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    flexShrink: 0,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: '#111827',
    margin: 0,
  },
  welcome: {
    fontSize: 12,
    color: '#9ca3af',
    marginTop: 2,
  },
};

export default TopBar;